export const PROD_URL = 'garyvalentine.republicrecords.com';
export const TWEET_HASHTAGS = ['LicoricePizza'];
export const GENERATE_NAME = 'Generate Name';
export const TWEET_CTA = 'Share';
export const TRY_AGAIN = 'Try Again';
export const INTRO_PROMPT = 'Opens in select theatres Friday';
export const INTRO_DATE = 'Everywhere Christmas Day';
export const INTRO_BTN_TEXT = 'Continue';
export const SPOTIFY_LOADING_TEXT = 'Hang tight...';
